import { render } from "./SetSecurityCode.vue?vue&type=template&id=65e4ec5b&scoped=true"
import script from "./SetSecurityCode.vue?vue&type=script&lang=js"
export * from "./SetSecurityCode.vue?vue&type=script&lang=js"

import "./SetSecurityCode.vue?vue&type=style&index=0&id=65e4ec5b&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e4ec5b"]])

export default __exports__